import { Canceler } from 'axios';
import { QUERY_PARAM } from '@config/routing';
import { differenceBy } from '@helpers/data';
import { parseQueryBoolean, parseQueryInt } from '@helpers/routing';
import { JsonFetchResult } from '@services/base/json-fetch';
import { ParseQueryKeepResults, ParseQueryListAttributes, ParseQueryPage } from './types';

/**
 * @todo
 * move to helpers/routing.ts
 */

export const parseQueryPage: ParseQueryPage = query => {
  return parseQueryInt(query, QUERY_PARAM.PAGE);
};
export const parseQueryKeepResults: ParseQueryKeepResults = query => {
  return parseQueryBoolean(query, QUERY_PARAM.KEEP_RESULTS);
};
export const parseQueryListAttributes: ParseQueryListAttributes = query => {
  const page = parseQueryPage(query);
  const keepResults = parseQueryKeepResults(query);
  return {
    page,
    keepResults
  };
};
export const fetchListCumulatively = <I extends Record<string, unknown>, REQ_D extends {
  limit: number;
  offset: number;
}, RES_D extends {
  items: I[];
  totalCount: number;
}>(args: {
  service: (requestData: REQ_D) => JsonFetchResult<RES_D>;
  requestData: REQ_D;
  loadedItemsIds: string[];
  key: string;
}): {
  promise: Promise<RES_D>;
  cancel: Canceler;
} => {
  const {
    requestData,
    loadedItemsIds,
    service,
    key
  } = args;
  let listRequestData = requestData;
  let listResponseData = (({
    items: [],
    totalCount: 0
  } as unknown) as RES_D);

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  let cancel: Canceler = () => {};
  const serviceRunCumulatively = async () => {
    while (listResponseData.items.length < requestData.limit) {
      const _service = service(listRequestData);
      cancel = _service.cancel;
      const data = await _service.promise;
      if (!data.totalCount) {
        break;
      }

      /**
       * check intersections inside while loop
       */
      listResponseData = {
        ...listResponseData,
        items: differenceBy(data.items, listResponseData.items, key),
        totalCount: data.totalCount
      };

      /**
       * check intersections with loaded (store)
       */
      if (loadedItemsIds.length) {
        listResponseData = {
          ...listResponseData,
          items: differenceBy(listResponseData.items, loadedItemsIds.map(id => ({
            [key]: id
          })), key)
        };
      }
      listRequestData = {
        ...listRequestData,
        offset: listRequestData.offset + listRequestData.limit
      };
    }

    /**
     * Slice result array to accumulatedDataItemsLimit
     */
    if (listResponseData.items.length > requestData.limit) {
      listResponseData = {
        ...listResponseData,
        items: listResponseData.items.slice(0, requestData.limit)
      };
    }
    return listResponseData;
  };
  return {
    promise: serviceRunCumulatively(),
    cancel
  };
};